export default __webpack_public_path__ + "static/media/Warlord's Mystic Blade.4ec7a294.jpg";